// Gemeinsame Formatter fuer den Lernen-Tab. Halten Komponenten von Boilerplate frei.

export function formatHmm(seconds: number): string {
  if (seconds <= 0) return '0 min';
  const hours = Math.floor(seconds / 3600);
  const mins = Math.round((seconds % 3600) / 60);
  if (hours === 0) return `${mins} min`;
  if (mins === 0) return `${hours} h`;
  return `${hours} h ${mins} min`;
}

export function formatEur(value: number | null): string {
  if (value === null) return 'unbekannt';
  return value.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: value >= 10 ? 2 : 4,
    maximumFractionDigits: 4,
  });
}

export function formatUsd(value: number | null): string {
  if (value === null) return 'unbekannt';
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: value >= 10 ? 2 : 4,
    maximumFractionDigits: 4,
  });
}

export function formatTokens(value: number | null): string {
  if (value === null) return 'unbekannt';
  return value.toLocaleString('de-DE');
}

export function formatRelative(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime();
  if (ms < 60_000) return 'gerade eben';
  if (ms < 3_600_000) return `vor ${Math.floor(ms / 60_000)} min`;
  if (ms < 86_400_000) return `vor ${Math.floor(ms / 3_600_000)} h`;
  if (ms < 30 * 86_400_000) return `vor ${Math.floor(ms / 86_400_000)} Tagen`;
  return new Date(iso).toLocaleDateString('de-DE');
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('de-DE');
}

// Feste Farbpalette pro TutorUsage-Source, damit Donut + Bars konsistent
// gefaerbt sind. Unbekannte Sources fallen auf grau zurueck.
export const SOURCE_COLORS: Record<string, string> = {
  tutor: '#A78BFA',
  voiceTutor: '#60A5FA',
  oralExam: '#FB923C',
  scoring: '#34D399',
  aiQuiz: '#FBBF24',
  flashcard: '#F87171',
};

export const SOURCE_LABELS: Record<string, string> = {
  tutor: 'KI-Tutor (Text)',
  voiceTutor: 'Voice-Tutor',
  oralExam: 'Mündliche Prüfung',
  scoring: 'Quiz-Scoring',
  aiQuiz: 'KI-Quiz',
  flashcard: 'Karteikarten',
};

export function sourceLabel(source: string): string {
  return SOURCE_LABELS[source] ?? source;
}

export function sourceColor(source: string): string {
  return SOURCE_COLORS[source] ?? '#686888';
}
